import { TFunction } from 'i18next'

import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

import { Td } from './styled-components'

interface TesterRowProps {
  fullName: string
  email: string
  addedBy: string
  addedAt: string
  onRemove: () => void
  t: TFunction
}

const TesterRow = ({ fullName, email, addedBy, addedAt, onRemove, t }: TesterRowProps) => (
  <tr>
    <Td>{fullName}</Td>
    <Td>{email}</Td>
    <Td>{addedBy}</Td>
    <Td>{addedAt}</Td>
    <Td>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton block={false} onClick={onRemove}>
        {t('beta_features.remove')}
      </SDButton>
    </Td>
  </tr>
)

export default TesterRow
